import { lazy } from 'react';

export const LocoAdminPage = lazy(() => import('./LocoAdminPage'));
